import React from "react";
import PermitBoundariesTab from "../../components/PermitBoundariesTab";
import { Permit } from "../../models/Permit";
import { AppState } from "../../store";
import { connect } from "react-redux";
import { User } from "../../models/User";

interface PermitContainerProps {
    permit: Permit | null;
    isReadOnly: boolean;
    currentUser: User | null;
    arcgisToken?: string;
}

const PermitBoundariesTabContainer: React.FC<PermitContainerProps> = ({
    permit,
    isReadOnly,
    currentUser,
    arcgisToken,
}) => {
    if (!permit || !currentUser || !currentUser.client.esriConfig) return null;

    return (
        <PermitBoundariesTab
            esriConfig={currentUser.client.esriConfig}
            areas={permit.areas}
            isReadOnly={isReadOnly}
            project={permit.project}
            arcgisToken={arcgisToken}
        />
    );
};

function mapStateToProps(state: AppState) {
    return {
        permit: state.permitPage.permit,
        currentUser: state.user.currentUser,
        arcgisToken: state.appControl.arcgisToken?.value,
    };
}

const mapDispatchToProps = (dispatch: any) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PermitBoundariesTabContainer);
